<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="toggleDialog"
    max-width="500px"
    class="workflow-description-required-dialog"
  >
    <v-card class="pa-4">
      <v-card-title class="pa-0">
        <span class="text-h5">Workflow Description Required</span>
      </v-card-title>
      <v-card-text class="pa-0 mt-6">
        To use AI features, please add a description to your workflow. This helps the AI understand your business
        context and generate more accurate results.
      </v-card-text>
      <v-card-text class="pa-0 mt-4">
        You can add an AI prompt in the workflow settings under the AI Settings tab.
      </v-card-text>
      <v-card-actions class="justify-end pa-0 mt-6" style="padding: 0 !important;">
        <v-btn
          rounded="lg"
          size="large"
          variant="outlined"
          data-test="workflow-description-dialog-cancel"
          @click="toggleDialog(false)"
        >
          Cancel
        </v-btn>
        <v-btn
          rounded="lg"
          size="large"
          variant="flat"
          color="primary"
          data-test="workflow-description-dialog-open-settings"
          @click="openSettings"
        >
          Open Settings
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { useStore } from 'vuex'

const { modelValue } = defineProps({ modelValue: Boolean })
const emit = defineEmits(['update:modelValue'])

const store = useStore()

const toggleDialog = (value) => {
  emit('update:modelValue', value)
}

const openSettings = () => {
  store.dispatch('workflow/openWorkflowSettings', { tab: 'AI' })
  toggleDialog(false)
}
</script>
